<h2 mat-dialog-title>Add Emergency Contact</h2>
<mat-dialog-content>
    <form fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" [formGroup]="contactForm">
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="First Name" formControlName="firstName" autofocus required />
            <mat-error>
                <app-validation-message [touched]="fields.firstName.touched" [errors]="fields.firstName.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="Last Name" formControlName="lastName" required />
            <mat-error>
                <app-validation-message [touched]="fields.lastName.touched" [errors]="fields.lastName.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>

        <mat-form-field class="full-width">
            <input type="email" lowercase-inp matInput placeholder="Email" formControlName="email" />
            <mat-error>
                <app-validation-message [touched]="fields.email.touched" [errors]="fields.email.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" (input)="filterNumbersOnly('userId')" matInput placeholder="User Id" formControlName="userId" />
            <mat-error>
                <app-validation-message [touched]="fields.userId.touched" [errors]="fields.userId.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="Authority" formControlName="authority" />
            <mat-error>
                <app-validation-message [touched]="fields.authority.touched" [errors]="fields.authority.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="Phone" formControlName="phone" (input)="filterNumbersOnly('phone')" required />
            <mat-error>
                <app-validation-message [touched]="fields.phone.touched" [errors]="fields.phone.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" (input)="filterNumbersOnly('phoneExt')" matInput placeholder="Phone Ext" formControlName="phoneExt" />
            <mat-error>
                <app-validation-message [touched]="fields.phoneExt.touched" [errors]="fields.phoneExt.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <select matNativeControl appearance="outline" placeholder="Phone Type" formControlName="phoneType" required>
                <option *ngFor="let type of phoneTypeList" [value]="type.value">
                    {{ type.label }}
                </option>
            </select>
            <mat-error>
                <app-validation-message [touched]="fields.phoneType.touched" [errors]="fields.phoneType.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <mat-form-field class="full-width">
            <input type="text" matInput placeholder="Passcode" formControlName="passcode" />
            <mat-error>
                <app-validation-message [touched]="fields.passcode.touched" [errors]="fields.passcode.errors"></app-validation-message>
            </mat-error>
        </mat-form-field>
        <div class="full-width">
            <mat-checkbox formControlName="ecv">Enhanced Call Verification (ECV)</mat-checkbox>
            <mat-error>
                <app-validation-message [touched]="fields.ecv.touched" [errors]="fields.ecv.errors"></app-validation-message>
            </mat-error>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <a mat-stroked-button id="cancel" (click)="cancel.emit()">Cancel</a>
    <button mat-raised-button color="primary" class="new-primary-button" (click)="saveAction()" type="button">Save Contact</button>
</mat-dialog-actions>
